// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"6806bad4","453":"30d9ad1d","732":"c1992b07","977":"0d7cea31"}[chunkId] + ".chunk.js";
};